import React, { useState, useCallback, useEffect } from 'react';
import { SectionContentTitle, Text } from '../../textVariations';
import { addZeroToDigit } from '../helper/TimerHelpers';
import { SessionTimerTypes } from '../SessionTimerTypes';
import { generalSessionTimerConstants } from '../constants/generalConstants';
import { Icon } from '../../../utilities/icomoon-css';
import { useFormik } from 'formik';
import { modalLoginFormSchema } from '../../../sections/userFlows/components/formValidationSchema';
import { UserFlowError } from '../../../sections/userFlows/components/UserFlowError';

export const SessionExpiryWarningModal = ({
  minutes,
  seconds,
  bodyHeight,
  closeHandler,
  sessionExtendCallHandler,
  currentCount,
}: SessionTimerTypes.TSessionExpiryWarningModal) => {
  const {
    modalTitle,
    modalMessage1,
    modalMessage2,
    tempSignInBtnText,
    tempContinueBtnText,
  } = generalSessionTimerConstants;
  const [error, setError] = React.useState<any>();
  const [hasError, setHasError] = React.useState(false);

  const LoginField = useCallback(({ error, hasError }) => {
    const [passwordShow, setPasswordShow] = useState(false);
    useEffect(() => {
      formik.setFieldValue('password', '');
      formik.setTouched({});
    }, [hasError]);
    const togglePassword = () => {
      setPasswordShow(!passwordShow);
    };
    const formik = useFormik({
      initialValues: {
        password: '',
      },
      validationSchema: modalLoginFormSchema,
      onSubmit: values => {
        sessionExtendCallHandler(
          values.password,
          closeHandler,
          currentCount,
          setError,
          setHasError
        );
      },
    });

    return (
      <form onSubmit={formik.handleSubmit}>
        <label className="passwordLabel">
          Password
          <span className="requiredLoginAsterisk">*</span>
        </label>
        <br></br>
        <div className="control has-icons-right">
          <input
            id="password"
            name="password"
            type={passwordShow ? 'text' : 'password'}
            placeholder="password"
            className="is-flex inputLoginField"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            data-testid="input-password"
          />
          <span className="icon is-small is-right">
            <span className="is-clickable" onClick={() => togglePassword()}>
              {passwordShow ? (
                <Icon name="tfw-show-bold-cp" color="black" size={14} />
              ) : (
                <Icon name="tfw-hide-bold-cp" color="black" size={14} />
              )}
            </span>
          </span>
        </div>
        {formik.touched.password && formik.errors.password ? (
          <div className="errorLoginSection">
            <div className="errorLoginIconSpace">
              <Icon name="tfw-danger-triangle-cp" size={12} color="red" />
            </div>
            <p className="errorLoginMessage">{formik.errors.password}</p>
          </div>
        ) : (
          <></>
        )}
        {UserFlowError(hasError, error)}
        <div className="buttonSection">
          <button
            className="button is-highlight"
            disabled={!formik.isValid || !formik.dirty}
            onClick={_e => formik.handleSubmit}
          >
            {tempSignInBtnText}
          </button>
          <button className="button close-modal-btn" onClick={closeHandler}>
            {tempContinueBtnText}
          </button>
        </div>
      </form>
    );
  }, []);

  return (
    <div
      className="modal expiryWarningModal"
      style={{
        marginTop: bodyHeight,
      }}
    >
      <div className="modal-background" />
      <div className="modal-card expiryWarningModalCard">
        <section className="modal-card-body">
          <div className="modalHeader">
            <button onClick={closeHandler}>
              <span>
                <Icon name="tfw-close-circle-cp" />
              </span>
            </button>
          </div>
          <SectionContentTitle RenderAs="h4">{modalTitle}</SectionContentTitle>
          <hr />
          <Text renderAs={'p'}>{modalMessage1}</Text>
          <SectionContentTitle RenderAs="h4">
            <span>
              <span>{addZeroToDigit(minutes)}</span>:
              <span>{addZeroToDigit(seconds)}</span>
            </span>
          </SectionContentTitle>
          <Text renderAs={'p'}>{modalMessage2}</Text>
          <LoginField error={error} hasError={hasError} />
        </section>
      </div>
    </div>
  );
};
